export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabStorico.vue?vue&type=template&id=8bdd675a&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabStorico.vue?vue&type=template&id=8bdd675a&
// module id = 902
// module chunks = 0